import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getNotifications, markNotificationRead } from '../api/notifications';

const QUERY_KEY = ['notifications', 'unread'];

export function useNotifications() {
  const queryClient = useQueryClient();

  const { data: notifications = [] } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => getNotifications(true),
    refetchInterval: 60_000,
  });

  const markRead = async (id: string) => {
    await markNotificationRead(id);
    queryClient.invalidateQueries({ queryKey: QUERY_KEY });
  };

  return { notifications, unreadCount: notifications.length, markRead };
}
